<template>
  <a
    href="#content"
    aria-label="link to next section"
    aria-describedby="content"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      :class="styles"
    >
      <path
        d="M20.0156 11.0156L12.0156 19.0156L4.01563 11.0156"
        stroke-width="3"
      />
      <path d="M12 18L12 2" stroke-width="3" />
    </svg>
  </a>
</template>

<script setup lang="ts">
import { ThemeType } from "@/types/types";
import { computed, toRefs } from "vue";

const props = defineProps<{
  isUmbraco?: boolean;
  themeType: "dark" | "light";
}>();
const { themeType, isUmbraco } = toRefs(props);

const styles = computed(() => {
  const color =
    isUmbraco.value && themeType.value === "dark"
      ? "stroke-white"
      : isUmbraco.value && themeType.value === "light"
      ? "stroke-aubergine"
      : "stroke-typography";
  return `${color} themeTransition`;
});
</script>
